module.exports = __webpack_public_path__ + "img/DOE-Logo@4x1_2.fe824361.svg";